import { HomeProductSwiperBreakPoints } from "@/constants/BreakPoints";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useState } from "react";

import ArrowIcon from "@/components/icons/ArrowIcon";
import ProductCard from "@/components/global/ProductCard";
import { v4 as uuidv4 } from "uuid";

const ProductsBulk = ({ title, products, locale }) => {
  const [swiper, set_swiper] = useState({});

  return products?.length ? (
    <section>
      <p className="font-bold sm:text-xl text-primary-800 text-start">
        {title}
      </p>
      {/* Please Replace This Section With Product Swiper  */}
      {/* I Tried to link but i can't as it linked already with an api */}
      <div className="relative">
        <Swiper
          onInit={(e) => set_swiper(e)}
          loop
          key={locale}
          dir={locale === "ar" ? "rtl" : "ltr"}
          className="mt-4"
          spaceBetween={20}
          modules={[Autoplay]}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          breakpoints={HomeProductSwiperBreakPoints}
        >
          {products.map((product) => (
            <SwiperSlide key={uuidv4()}>
              <ProductCard product={product} />
            </SwiperSlide>
          ))}
        </Swiper>
        {products?.length >= 5 && (
          <>
            <div
              onClick={() => swiper?.slidePrev()}
              className="cursor-pointer absolute top-1/3 -left-3 z-30 size-7 rounded-full bg-purple-600 text-white max-[640px]:hidden max-[768px]:flex min-[768px]:hidden max-[1023px]:hidden lg:flex items-center justify-center"
            >
              <ArrowIcon className="rotate-180 size-4" />
            </div>
            <div
              onClick={() => swiper?.slideNext()}
              className="cursor-pointer absolute top-1/3 -right-3 z-30 size-7 rounded-full bg-purple-600 text-white max-[640px]:hidden max-[768px]:flex min-[768px]:hidden max-[1023px]:hidden lg:flex items-center justify-center"
            >
              <ArrowIcon className="size-4" />
            </div>
          </>
        )}
      </div>
    </section>
  ) : null;
};

export default ProductsBulk;
